import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  getRouterParams,
  StateInterface
} from '../../app.reducers';
import { fetchItemError } from './fetch-item-error/fetch-item-error.reducer';
import { fetchItemInProgress } from './fetch-item-in-progress/fetch-item-in-progress.reducer';
import { items } from './items/items.reducer';
import { WatchlistSnapshot } from '../model/watchlist-snapshot';


/**
 * Feature state for watchlist snapshots
 */
export interface WatchlistSnapshots {
  fetchItemInProgress: boolean;
  fetchItemError: any;
  items: {[uuid: string]: WatchlistSnapshot};
  selectedItemUuid: string;
}

/**
 * Application state interface extended with feature state
 */
export interface State extends StateInterface {
  watchlistSnapshots: WatchlistSnapshots;
}

export const reducers = {
  fetchItemError,
  fetchItemInProgress,
  items
};

export const getWatchlistSnapshotsState = createFeatureSelector<WatchlistSnapshots>('watchlistSnapshots');

export const getFetchItemInProgress = createSelector(getWatchlistSnapshotsState,
  (state: WatchlistSnapshots) => state.fetchItemInProgress);
export const getItems = createSelector(getWatchlistSnapshotsState,
  (state: WatchlistSnapshots) => state.items);

export const getSelectedItem = createSelector(getItems, getRouterParams, (_items, _routerParams) => _items[_routerParams['uuid']]);

/**
 * Returns the childLists for the selected item
 *
 * @type {MemoizedSelector<object, Watchlist[]>}
 */
export const getSelectedItemChildLists = createSelector(getSelectedItem, getItems,
  (_selectedItem, _items): WatchlistSnapshot[] => {
    if (_selectedItem) {
      return Object.keys(_items).map(uuid => _items[uuid]).filter(item => item.parentUuid === _selectedItem.uuid);
    } else {
      return null;
    }
  }
);

/**
 * Returns the parentList of the selected item, if it exists
 *
 * @type {MemoizedSelector<object, Watchlist>}
 */
export const getSelectedItemParentList = createSelector(getSelectedItem, getItems,
  (_selectedItem, _items): WatchlistSnapshot => {
    if (_selectedItem) {
      return Object.keys(_items).map(uuid => _items[uuid]).find(item => item.uuid === _selectedItem.parentUuid);
    } else {
      return null;
    }
  }
);
